import renderProductImage from './render_product_image';
import renderProductDescription from './render_product_description';
import renderProductTotals from './render_product_totals';

function getProductHTML(detailsContainer, productTotals) {
    "use strict";

    return `<div class="cart-modal__product">
        ${detailsContainer}
        ${productTotals}
    </div>`;
}

function getProductDetailsContainerHTML(productImage, productDescription, productLink) {
    "use strict";

    return `<a href="${productLink}">
          ${productImage}
          ${productDescription}
    </a>`;
}

function getProductDetailsNoLinkContainerHTML(productImage, productDescription) {
    "use strict";

    return `<span>
          ${productImage}
          ${productDescription}
    </span>`;
}

function renderProductDetailsContainer(productImage, manufacturer, details, productLink) {
    "use strict";

    var html = (productLink) ? getProductDetailsContainerHTML : getProductDetailsNoLinkContainerHTML;
    return html(
        renderProductImage(productImage),
        renderProductDescription(manufacturer, details),
        productLink
    );
}

function renderProduct(product) {
    "use strict";

    var productImage = product.hasImage ? product.productImage : product.noImageUrl;

    return getProductHTML(
        renderProductDetailsContainer(productImage, product.manufacturer, product.details, product.url),
        renderProductTotals(product.quantity, product.outOfStock)
    );
}

export default renderProduct;